module.exports = __webpack_public_path__ + "static/img/12.958fedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/12.png
// module id = 3VqS
// module chunks = 0